import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useMediaQuery } from 'react-responsive';
import { Chart } from 'chart.js/auto';
import { prettyDOM } from '@testing-library/react';

const Plan = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });

  const [rate, setRate] = useState(1);
  const [duration, setDuration] = useState(1);
  const [amount, setAmount] = useState(0);
  const [interest, setInterest] = useState(0);
  const [activeButton, setActiveButton] = useState('Yr');
  const [amountPerMonth, setAmountPerMonth] = useState(0)

  const handleAmount = (e) => {
    setAmount(e.target.value);
    CalculateEmi(e.target.value, rate, duration);
  };

  const handleSliderChange = (e) => {
    setRate(e.target.value);
    CalculateEmi(amount, e.target.value, duration);
  };

  const handleDuration = (e) => {
    setDuration(e.target.value);
    CalculateEmi(amount, rate, e.target.value);
  };

  const CalculateEmi = (p, r, t) => {
    if(activeButton === 'Mo'){
      t = t/12;
    }
    // console.log("time",time)
    const calculatedInterest = (p * r * t) / 100;
    setInterest(calculatedInterest);
    CalculatePerMonthEmi(parseInt(calculatedInterest) + parseInt(amount))
  };

  //function to calculate per month emi
  const CalculatePerMonthEmi = (amt) => {
    var data = 0;
    if(activeButton === 'Mo'){
      data = amt/parseInt(duration);
    }else{
      data = amt/(parseInt(duration)*12);
    }

    // console.log("data", parseInt(data))
    setAmountPerMonth(parseInt(data))
  }

  // Function to handle button click and set active state
  const handleButtonClick = (button) => {
    setActiveButton(button);
    CalculateEmi(parseInt(amount), rate, duration)
    CalculatePerMonthEmi(parseInt(interest)+parseInt(amount))
  };

  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  // Update chart when amount or interest changes
  useEffect(() => {
    // Check if chart exists, then destroy before creating a new one
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (chartRef && chartRef.current) {
      const myChartRef = chartRef.current.getContext('2d');
      
      // Create the chart
      chartInstance.current = new Chart(myChartRef, {
        type: 'pie',
        data: {
          // labels: ["Principal Amount", "Interest Payable"],
          datasets: [
            {
              data: [amount, interest], // Dynamic data
              backgroundColor: ['#F3E3F8', '#48025C'],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false, // For responsiveness
        },
      });
    }
  }, [amount, interest]); // Run effect on amount or interest change

  return (
    <div className='plan-section mt-7' id='plan-section'>
      <Container>
        <Row>
          <Col lg={7} md={7} xs={12} style={{ paddingRight: isMobile ? '' : '15%', padding: isMobile ? '10%' : '' }}>
            <h1>Plan Your Purchase</h1>
            <h1>with IRA Aspiration</h1>
            <h6>Calculate Your EMI</h6>
            <div className='d-flex'>
              <p>Loan Amount</p> 
              <IoMdInformationCircleOutline />
            </div>
            <Form.Control type="text" placeholder="₹5,00,000" className='mb-4' style={{ width: '50%' }} onChange={handleAmount} value={amount === 0 ? "" : amount}/>
            
            <div className={`d-flex justify-content-between ${isMobile ? 'mt-4' : ''}`}>
              <div className='d-flex'>
                <p>Rate of Interest</p>
                <IoMdInformationCircleOutline />
              </div>
              <div className='interest'>
                <span>{rate}% P.A</span>
              </div>
            </div>
            
            <input 
              type="range" 
              className="form-range range-slider" 
              id="customRange1" 
              min="1" 
              max="100" 
              value={rate} 
              onChange={handleSliderChange} 
              style={{background: `linear-gradient(to right, #48025C ${rate}%, #ddd ${rate}%)`}} 
            />

            <div className='d-flex justify-content-between' style={{ marginTop: isMobile ? '12%' : '10%' }}>
              <div className='d-flex'>
                <div className='d-flex' style={{ marginRight: isMobile ? '' : '30px' }}>
                  <p>Loan Tenure</p>
                  <IoMdInformationCircleOutline />
                </div>
                <div style={{marginLeft : isMobile ? '10px' : '', marginTop : isMobile ? '-5px' : ''}}>
                  <button className='time-yr time-toggle' onClick={() => handleButtonClick('Yr')} style={{
                  backgroundColor: activeButton === 'Yr' ? '#48025C' : '#fff',
                  color: activeButton === 'Yr' ? '#fff' : '#000',
                }}>Yr</button>
                  <button className='time-mth time-toggle' onClick={() => handleButtonClick('Mo')} style={{
                  backgroundColor: activeButton === 'Mo' ? '#48025C' : '#fff',
                  color: activeButton === 'Mo' ? '#fff' : '#000',
                }}>Mo</button>
                </div>
              </div>
              <div className='interest'>
                <span style={{ padding: isMobile ? '4px 13px' :'4px 15px' }}>{duration} {activeButton}</span>
              </div>
            </div>
            
            <input 
              type="range" 
              className="form-range range-slider" 
              id="customRange2" 
              min="1" 
              max="100" 
              value={duration} 
              onChange={handleDuration} 
              style={{background: `linear-gradient(to right, #48025C ${duration}%, #ddd ${duration}%)`}} 
            />
          </Col>

          <Col lg={5} md={5} xs={12} style={{ padding: isMobile ? '10%' : '' }}>
            <div className='calculated-emi'>
              <div className='heading-emi'>
                <div className='d-flex mb-2'>
                  <span>Per Month EMI</span> 
                  <IoMdInformationCircleOutline />
                </div>
                <div className='d-flex'>
                  <h5>₹{amountPerMonth}/</h5>
                  <h6 className='d-flex align-items-center'>Month</h6>
                </div>
              </div>
              <div className='peview-amt'>
                <Row className='mb-2'>
                  <Col><span>Principal</span></Col>
                  <Col><h6>₹{parseInt(amount)}</h6></Col>
                </Row>
                <Row className='mb-4'>
                  <Col><span>Total Interest</span></Col>
                  <Col><h6>₹{parseInt(interest)}</h6></Col>
                </Row>
                <Row>
                  <Col><span>Total Amount</span></Col>
                  <Col><h6 style={{color: '#48025C'}}>₹{parseInt(amount) + parseInt(interest)}</h6></Col>
                </Row>
              </div>
              <div className='d-flex justify-content-between align-items-center chart-div'>
                <div style={{ width: isMobile ? "100px" : "150px", height: isMobile ? "100px" : "150px" }}>
                  <canvas ref={chartRef} />
                </div>
                <div className="chart-label">
                  <div>
                    <button style={{ backgroundColor: '#48025C' }}></button><span>Interest payable</span>
                  </div>
                  <div>
                    <button style={{ backgroundColor: '#F3E3F8' }}></button><span>Principal Amount</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='connect-section d-flex align-items-center justify-content-between'>
              <span>Contact Us for Loan Assistance</span>
              <button className='avail2'>Connect</button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Plan;
